import { ColumnsType } from 'antd/es/table';
import { ColumnType } from 'antd/es/table/interface';
import { DataIndex } from 'rc-table/lib/interface';

export const cleanColumnsDataSource = <IDataType>(
    tableColumns: ColumnsType<IDataType>,
    tableData: IDataType[],
): { columns: ColumnsType<IDataType>; dataSource: IDataType[] } => {
    const columnsList = [
        'key',
        ...tableColumns
            .map((i) => i as ColumnType<IDataType>)
            .filter((i) => i.dataIndex)
            .map((column: ColumnType<IDataType>) => column.dataIndex)
            .filter((i) => i !== undefined),
    ] as DataIndex[];

    const dataColumnList: Array<string> = [];
    tableData.forEach((dataItem) => {
        Object.keys(dataItem as object).forEach((key) => {
            if (!dataColumnList.includes(key) && columnsList.includes(key)) {
                dataColumnList.push(key);
            }
        });
    });

    const cleanColumnsList = columnsList.filter((col: DataIndex) => dataColumnList.includes(col as string));

    const cleanColumns = tableData.length
        ? tableColumns.filter((col: ColumnType<IDataType>) => dataColumnList.includes(col.dataIndex as string))
        : tableColumns;

    const cleanDataSource = tableData.map((dataItem) => {
        const newItem: any = {};
        cleanColumnsList.forEach((col: DataIndex) => {
            newItem[col as string] = (dataItem as any)[col as string];
        });
        return newItem as IDataType;
    });
    return {
        columns: cleanColumns,
        dataSource: cleanDataSource,
    };
};
